import { FC, useState, PropsWithChildren } from 'react';
import { Box } from '@mui/material';
import Image from "next/legacy/image";
import { headerStyles } from './header.styles';
import Logo from '../logo/logo.component';
import SearchBar from '../header-search-bar/header-search-bar.component';
import HeaderNav from '../header-nav/header-nav.component';
import BurgerMenu from '../burger-menu/burger-menu.component';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton } from '@mui/material';
import { clsx, useStyles } from '@sweatpals/react-ui-kit';

export interface HeaderProps extends PropsWithChildren {
	type?: string;
}

const Header: FC<HeaderProps> = ({ children }) => {
	const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

	const handleOpenMenu = () => {
		setIsMenuOpen(true);
	};

	const handleCloseMenu = () => {
		setIsMenuOpen(false);
	};

	const styles = useStyles(headerStyles);

	return (
		<Box component="header" sx={styles.root}>
			<Box
				sx={clsx(styles.row, {
					display: isMenuOpen ? 'none' : 'flex',
				})}
			>
				<Logo type="dark-text" />
				<Box
					sx={{
						display: { xs: 'none', md: 'flex' },
					}}
				>
					<SearchBar />
				</Box>
				<HeaderNav />

				<Box
					sx={{
						display: { xs: 'flex', md: 'none' },
					}}
				>
					<IconButton
						onClick={handleOpenMenu}
						sx={{
							color: 'black',
						}}
					>
						<MenuIcon />
					</IconButton>
				</Box>
			</Box>
			<Box sx={styles.relative}>
				<BurgerMenu isOpen={isMenuOpen} onClose={handleCloseMenu} />
			</Box>
		</Box>
	);
};

export default Header;
